import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dynamic%20modern%20sports%20complex%20with%20athletes%20in%20motion%2C%20warm%20sunset%20lighting%2C%20basketball%20and%20soccer%20players%20silhouettes%2C%20clean%20architectural%20lines%2C%20energetic%20atmosphere%2C%20cinematic%20sports%20photography%20style%20with%20dramatic%20warm%20golden%20hour%20light%2C%20abstract%20geometric%20elements&width=1800&height=900&seq=hero-yunkai-sports&orientation=landscape"
        alt="云开体育 - 专业体育服务平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-6">
          <i className="ri-sparkling-line text-accent-400 text-sm"></i>
          <span className="text-accent-300 text-sm font-medium">新会员注册即享 7 天免费体验</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-4 tracking-tight">
          {heroData.title}
        </h1>
        <p className="text-xl md:text-2xl text-background-50/80 font-light mb-3">
          {heroData.subtitle}
        </p>
        <p className="text-base md:text-lg text-background-50/60 max-w-2xl mx-auto mb-8 leading-relaxed">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-14">
          <Link
            to="/category/membership"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all hover:scale-105"
          >
            {heroData.ctaPrimary}
          </Link>
          <Link
            to="/category/training"
            className="px-8 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 font-semibold text-base whitespace-nowrap cursor-pointer hover:bg-background-50/15 transition-all"
          >
            {heroData.ctaSecondary}
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {heroData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-3xl md:text-4xl font-bold text-accent-400">{stat.value}</div>
              <div className="text-background-50/70 text-sm mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}